//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import {
  IToastNotification,
  ToastType,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { pluralize } from '@utils/stringUtils';

const baseToastNotif = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
};

const CONTACT_SUPPORT_MESSAGE =
  'Please try again later or contact Bazaarvoice Support.';

export const addLike2BuyItemsSucceededToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Media Added to Like2Buy',
    message: `Successfully added ${pluralize(
      itemCount,
      'item',
    )} to your Instagram Like2Buy store.`,
  };
};

export const addLike2BuyItemsFailedToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Failed to Add Media to Like2Buy',
  message: `We were unable to add your media to your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
};

export const pinLike2BuyItemsSucceededToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Media Pinned in Like2Buy',
    message: `Successfully pinned ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store.`,
  };
};

export const unpinLike2BuyItemSucceededToast = {
  ...baseToastNotif,
  title: 'Media Unpinned in Like2Buy',
  message: `Successfully unpinned 1 item from your Instagram Like2Buy store.`,
};

export const pinLike2BuyItemsFailedToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Failed to Pin Items from Like2Buy',
    message: `We were unable to pin ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
    type: ToastType.ERROR,
  };
};

export const unpinLike2BuyItemFailedToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Failed to Unpin Items from Like2Buy',
    message: `We were unable to unpin ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
    type: ToastType.ERROR,
  };
};

export const reorderLike2BuyItemFailedToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Failed to Reorder Pinned Items from Like2Buy',
  message: `We were unable to reorder pinned items from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
};

export const publishLike2BuyItemSucceededToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Media Published to Like2Buy',
  message: 'Successfully published 1 item to your Instagram Like2Buy store.',
};

export const publishLike2BuyItemFailedToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Failed to Publish Media to Like2Buy',
  message: `We were unable to publish 1 item from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
};

export const hideLike2BuyItemsSucceededToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Media Hidden from Like2Buy',
    message: `Successfully hid ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store.`,
  };
};

export const hideLike2BuyItemsFailedToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Failed to Hide Media from Like2Buy',
    message: `We were unable to hide ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
    type: ToastType.ERROR,
  };
};

export const deleteLike2BuyItemsSucceededToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Media Deleted from Like2Buy',
    message: `Successfully deleted ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store.`,
  };
};

export const deleteLike2BuyItemsFailedToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Failed to Delete Media from Like2Buy',
    message: `We were unable to delete ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
    type: ToastType.ERROR,
  };
};

export const updateLike2BuyItemsFailedToast = (
  itemCount: number,
): IToastNotification => {
  return {
    ...baseToastNotif,
    title: 'Failed to Update Media from Like2Buy',
    message: `We were unable to update ${pluralize(
      itemCount,
      'item',
    )} from your Instagram Like2Buy store. ${CONTACT_SUPPORT_MESSAGE}`,
    type: ToastType.ERROR,
  };
};

export const getLike2BuyPreviewFailedToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Failed to Open Like2Buy Preview',
  message: `We were unable to generate a preview for your Instagram Like2BuyStore. ${CONTACT_SUPPORT_MESSAGE}`,
  type: ToastType.ERROR,
};
